<div
  class="index-layout"
  [class.menu-collapsed]="!isMobile && isMenuCollapsed"
  [class.menu-open]="isMobile && isMenuOpen"
>
  <!-- Top Header - Full Width -->
  <app-page-header class="top-header"></app-page-header>

  <!-- Main Area (Menu + Content) -->
  <div class="main-area">
    <!-- Mobile Menu Toggle Button -->
    <button
      *ngIf="isMobile"
      class="mobile-menu-toggle"
      (click)="toggleMobileMenu()"
      [class.menu-open]="isMenuOpen"
      [style.left.px]="
        isMenuOpen ? mobileMenuToggleLeft.open : mobileMenuToggleLeft.closed
      "
    >
      @if (isMenuOpen) {
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M18 6L6 18M6 6l12 12"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
      } @else {
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M3 12h18M3 6h18M3 18h18"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
      }
    </button>

    @if (isMobile && isMenuOpen) {
    <div
      class="mobile-backdrop"
      (click)="onBackdropClick()"
      (keyup.escape)="onBackdropClick()"
      tabindex="-1"
    ></div>
    }

    <div class="menu-container">
      <app-menu-layout
        [isMobile]="isMobile"
        [isOpen]="isMenuOpen"
        (menuToggled)="onMenuToggle($event)"
      >
      </app-menu-layout>
    </div>

    <div class="content-container">
      <app-content-layout *ngIf="isInitialized">
        <ng-content #content></ng-content>
      </app-content-layout>
    </div>
  </div>
</div>
